/** Favicon URL for a registered platform chip (Google favicon service). */

/**
 * @param {object} svc Registered service row
 * @returns {string|null}
 */
export function serviceFaviconUrl(svc) {
  const raw = String(svc?.domain || svc?.profile_url || svc?.url || '').trim();
  if (!raw) return null;
  try {
    const href = raw.startsWith('http') ? raw : `https://${raw.replace(/^\/\//, '')}`;
    const host = new URL(href).hostname;
    if (!host || host.includes(' ')) return null;
    return `https://www.google.com/s2/favicons?domain=${encodeURIComponent(host)}&sz=32`;
  } catch {
    return null;
  }
}

export const REGISTERED_PLATFORMS_COLLAPSED_LIMIT = 8;
